import React, { useEffect, useMemo, useState } from "react";
import { InputGroup } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useAuth } from "../providers/authprovider";

export default function SearchBuildingBar({ onSelect, defaultValue, buildings, enabled = true }) {
  const {
    buildings: { getShort },
  } = useAuth();

  const [shortBuildings, setShortBuildings] = useState(() =>
    Array.isArray(buildings) ? buildings : null
  );

  // 1) jeśli przyszło buildings w propsach -> ustaw listę
  useEffect(() => {
    if (Array.isArray(buildings)) setShortBuildings(buildings);
  }, [buildings]);

  // 2) jeśli nie ma buildings w propsach -> pobierz raz z API
  useEffect(() => {
    if (shortBuildings !== null) return;

    let cancelled = false;

    getShort(({ success, content }) => {
      if (cancelled) return;
      setShortBuildings(success ? content || [] : []);
    });

    return () => {
      cancelled = true;
    };
  }, [getShort, shortBuildings]);

  const defaultBuilding = useMemo(() => {
    if (!defaultValue?.id) return null;
    if (!Array.isArray(shortBuildings)) return null;
    return shortBuildings.find((sb) => sb.id === defaultValue.id) || null;
  }, [defaultValue, shortBuildings]);

  const selectedValue = useMemo(() => {
    return defaultBuilding ? [defaultBuilding] : [];
  }, [defaultBuilding]);

  const handleSelectBuilding = (selected) => {
    const building = selected?.[0] || undefined;
    onSelect?.(building);
  };

  if (shortBuildings === null) return null; // loading state - możesz tu dać spinner

  return (
    <InputGroup className="mb-3">
      <InputGroup.Text id="search">Szukaj</InputGroup.Text>
      <Typeahead
        clearButton
        id="select_building_auto"
        className={"buildingEventSearchInput"}
        labelKey="name"
        onChange={handleSelectBuilding}
        options={shortBuildings}
        placeholder="Wybierz obiekt..."
        disabled={!enabled}
        selected={selectedValue} // ✅ kontrolowane, reaguje na zmianę defaultValue
      />
    </InputGroup>
  );
}
